import { Toast } from "antd-mobile";

let tramp = false;
export default function toastBeBounce (delay) {
  if (!tramp) {
    tramp = true;
    Toast.fail ("网络错误", 1);
    setTimeout (() => {
      tramp = false;
    }, delay);
  }
}
